
/**
 * bns.common Data 관리 클래스
 * @category bns.common
 * @memberof module:bns.ommon
 * @param  {Object} _config={} 설정
 */
class DataStore {
	constructor(_config={}){
		this.data = {
			config: _config,
		};

		this.apiUrlList = {
			BossCharacter: this.data.config.apiDomain + '/web/v2/characters/representativeCharacter', // 대표캐릭터
			CharacterList: this.data.config.apiDomain + '/game/v1/characters/group', // 내 보유 캐릭터목록
		};
	}

	getData(_key = '', _param={}, _callback = ()=>{}){
		if( this.data[_key] ){
			_callback(this.data[_key]);
			return this.data[_key];
		}else{
			axios.get(this.apiUrlList[_key], {
				params: _param,
				withCredentials: true
			})
			.then( (response) => {
				this.data[_key] = response.data;
				_callback(response.data);
				return response.data;
			})
			.catch( (error, d) => {
				console.log(_key, error,'----', d);
			})
			.then( (d) => {});
		}
	}

	changeBossChar(_charName='', _serverId=0, _serverType='', _callback = ()=>{}){
		axios({
			method: 'PUT',
			url: this.apiUrlList.BossCharacter,
			withCredentials: true,
			data: {
				characterName: _charName,
				serverId: _serverId,
				serverType: _serverType
			}
		})
		.then( (response) => {
			_callback(response.data);
		})
		.catch( (error, d) => {
			console.log('changeBossChar', error,'----', d);
		})
		.then( (d) => {
		});
	}

} // end of class
export default DataStore;